export default "__VITE_ASSET__CSivEMK$__"